<div class="modal wall-chart-update">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>

  <h1>{{data.title}}</h1>
  <p class="txt-16 mb-0050">

    <ng-container *ngIf="showOperators">
      <app-include-exclude-having-toggle *ngIf="showOperators"
                                         [hideAnyOrAll]="data.hideAnyOrAll"
                                         [targetType]="data.targetType"
                                         [operator]="dataCopy.operator"
                                         (operatorChange)="operatorChanged($event)"
                                         class="d-inline"
                                         [forTypeText]="forTypeText"></app-include-exclude-having-toggle>

      <span>added by: </span>
    </ng-container>

    <strong *ngIf="!showOperators">Only include {{targetTypeText}} with {{forTypeText}} added by:</strong>
  </p>

  <app-user-list-autocomplete [userIds]="dataCopy.userIds"
                              [campaignId]="campaignId"
                              (userIdsChange)="userIdsChanged($event)"></app-user-list-autocomplete>

  <p class="txt-16 mb-0050">
    <strong>during this time period:</strong>
  </p>

  <app-range-or-relative-date-input [inputTheme]="'white'"
                                    [ngModel]="dataCopy.dateRange"
                                    (ngModelChange)="dateRangeChanged($event)">
  </app-range-or-relative-date-input>

  <div class="col__ mt-0075"
       content-outlet="buttons">
    <button class="btn floatRight"
            type="button"
            (click)="onDone()">Done</button>
  </div>

</div>
